import type { Dictionary } from "../i18n";

const dictionary: Dictionary = {
  "success.pendingTitle": "Tu pedido sigue pendiente de confirmación",
  "success.pendingBody": "La confirmación del pago está tardando más de lo habitual. No vuelvas a pagar. Puedes comprobarlo de nuevo, volver a tu pedido o contactar con soporte indicando el número de pedido de abajo.",
  "success.cancelledTitle": "Este pedido se ha cancelado",
  "success.cancelledBody": "Si se cobró o se retuvo un importe en tu tarjeta, se te está devolviendo. No tienes que hacer nada.",
  "success.checkAgain": "Comprobar de nuevo",

  "error.countryClosed": "Ya no se aceptan pedidos nuevos ni pagos de pedidos pendientes en este país. Los pedidos pagados y la asistencia continúan.",
  "error.providerCountryClosed": "El proveedor asignado ya no puede completar tu pedido. Inicia un pedido nuevo y te asignaremos otro proveedor.",
  "chrome.reviewTitle": "Revisar y pagar",
  "chrome.paidTitle": "Confirmación del pedido",
  "chrome.paymentTitle": "Pago",
  "chrome.language": "Idioma",
  "chrome.close": "Cerrar",
  "chrome.logoAlt": "Tinkr",
  "common.loading": "Cargando",
  "common.error": "Algo ha salido mal.",
  "common.retry": "Volver a intentarlo",
  "common.labelSeparator": ": ",
  "trust.badge": "Vendido por Tinkr · Producido por un socio local de impresión autorizado",
  "review.orderSummary": "Resumen del pedido",
  "review.threeD": "3D",
  "review.specsQty": "Cant.",
  "review.delivery.title": "Entrega",
  "review.shipping.title": "Datos de envío",
  "review.shipping.edit": "Editar",
  "review.payment.title": "Método de pago",
  "review.payment.card": "Tarjeta de crédito o débito",
  "review.payment.cardHint": "Visa, Mastercard y más",
  "review.payment.usdc": "Stablecoin USDC",
  "review.payment.comingSoon": "Próximamente",
  "review.price.title": "Precio",
  "review.price.itemSubtotal": "Subtotal de artículos",
  "review.price.premium": "Producción premium",
  "review.price.shipping": "Envío",
  "review.price.shippingIncluded": "Incluido",
  "review.price.total": "Total del pedido",
  "review.price.taxNote": "Tinkr no cobra impuestos sobre la transacción de este pedido.",
  "review.price.updating": "Actualizando el total…",
  "review.price.refreshError": "No pudimos actualizar el total. Vuelve a cargar la página antes de pagar.",
  "review.price.multicolor": "Multicolor",
  "review.price.multicolorCapNote": "No pudimos medir esta figura con exactitud, así que se aplica el precio multicolor máximo.",
  "review.pricing.calculating": "Calculando tu precio exacto…",
  "review.pricing.calculatingBody": "Tu figura multicolor se calcula a partir de su propia impresión. Normalmente tarda menos de un minuto.",
  "review.pricing.from": "Desde",
  "review.pricing.stillWorking": "Seguimos trabajando. Gracias por tu paciencia.",
  "review.pricing.timeout": "No pudimos terminar de calcular tu precio. Inténtalo de nuevo.",
  "review.consent.prefix": "Al marcar esta casilla, aceptas los",
  "review.consent.terms": "Términos del servicio",
  "review.consent.and": "y la",
  "review.consent.privacy": "Política de privacidad de Tinkr",
  "review.cta.pay": "Pagar",
  "review.cta.secure": "Pago seguro",
  "coupon.toggle": "¿Tienes un código de cupón?",
  "coupon.label": "Código de cupón",
  "coupon.placeholder": "Introduce el código",
  "coupon.apply": "Aplicar",
  "coupon.applying": "Aplicando…",
  "coupon.remove": "Eliminar",
  "coupon.removing": "Eliminando…",
  "coupon.appliedLabel": "Cupón",
  "coupon.error.notFound": "No encontramos ese código de cupón",
  "coupon.error.expired": "Este cupón ha caducado",
  "coupon.error.revoked": "Este cupón ya no es válido",
  "coupon.error.notStarted": "Este cupón aún no está activo",
  "coupon.error.notApplicable": "Este cupón no se puede usar en este pedido",
  "coupon.error.usageLimit": "Este cupón ha alcanzado su límite de uso",
  "coupon.error.alreadyApplied": "Este cupón ya está aplicado",
  "coupon.error.retry": "Espera un momento y vuelve a intentarlo",
  "coupon.error.generic": "Este código no se puede usar",
  "redirect.title": "Te llevamos al pago seguro…",
  "redirect.subtitle": "Te estamos redirigiendo a la página de pago seguro de Stripe.",
  "redirect.badgeVerified": "Verificado",
  "redirect.badgeEncrypted": "Cifrado",
  "redirect.badgeSsl": "Conexión SSL segura",
  "success.title": "¡Pago completado!",
  "success.authorizedTitle": "¡Pedido confirmado!",
  "success.orderNumber": "Número de pedido",
  "success.paidTotal": "Importe pagado",
  "success.authorizedTotal": "Retención temporal en la tarjeta",
  "success.nextTitle": "Qué ocurre ahora",
  "success.step1": "Avisamos a tu socio de impresión",
  "success.step2": "Imprime y comprueba la calidad",
  "success.step3": "Te envía el pedido",
  "success.statusCompleted": "Completado",
  "success.statusPending": "En curso",
  "success.statusUpcoming": "Próximamente",
  "success.track": "Seguir tu pedido",
  "success.viewOrder": "Ver tu pedido →",
  "success.back": "Volver a Tinkr",
  "success.returnToDoodles": "Volver a Tinkr Doodles",
  "success.returnToSite": "Volver a tu pedido",
  "success.confirming": "Confirmando tu pedido…",
  "success.notConfirmed": "Aún no pudimos confirmar tu pedido. Vuelve a comprobarlo dentro de unos minutos.",
  "cancelled.title": "Has salido de la página de pago",
  "cancelled.body": "Tu pedido está guardado. El estado del pago puede tardar un momento en actualizarse.",
  "cancelled.orderRef": "Número de pedido",
  "cancelled.tip": "Comprueba tu conexión o la autorización bancaria y vuelve a intentarlo.",
  "cancelled.retry": "Volver a intentarlo",
  "cancelled.help": "Ayuda",
  "footer.terms": "Términos del servicio",
  "footer.privacy": "Privacidad",
  "footer.refund": "Reembolsos y cancelaciones",
  "footer.seller": "Información del vendedor",
  "footer.tokushoho": "Aviso de la Ley de transacciones comerciales especificadas",
  "footer.entity": "Tinkr App Ltd",
  "footer.companyNo": "Empresa n.º",
  "legal.back": "Volver",
  "legal.updated": "Última actualización",
  "error.notFound": "No encontramos este enlace de pago. Comprueba el enlace de tu correo.",
  "error.expired": "Este enlace de pago ha caducado.",
  "error.alreadyPaid": "Este pedido ya está pagado.",
  "error.payFailed": "No pudimos iniciar el pago. Vuelve a intentarlo.",
  "error.couponNoLongerValid": "El cupón de este pedido ya no es válido. Elimínalo y vuelve a intentarlo.",
  "error.couponLimitReached": "Este cupón ha alcanzado su límite de uso por ahora. Elimínalo para continuar o vuelve a intentarlo más tarde.",
  "error.couponNotApplicable": "Este cupón no se puede usar con el total de este pedido. Elimínalo y vuelve a intentarlo.",
  "error.paymentConfirming": "Tu pago ya se está confirmando. Espera un momento y luego actualiza esta página.",
  "error.sessionConflict": "El pago cambió en otra ventana. Vuelve a intentarlo.",
  "error.recoveryHint": "Abre el correo más reciente sobre tu pedido para obtener un enlace de pago nuevo o contacta con soporte y te ayudaremos.",
  "error.backToSite": "Volver al sitio"
};

export default dictionary;
